module.exports = __webpack_public_path__ + "static/ch-him2-lp-quiz-3-ec99bc51251fdb343e77bbfb88b529ac.jpg";